import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import utils from 'utils';
import { actionType } from 'utils/constants';

import CommonButton from 'components/Buttons/CommonButton';
import selectors from 'state/selectors';
import actions from 'state/actions';

const EditReportNotification = () => {
  const t = utils.intl.useTranslator();
  const dispatch = useDispatch();

  const selectedRow = useSelector(selectors.configurator.getSelectedReportSettings);
  const formMode = useSelector(selectors.configurator.getFormModeReports);

  return (
    <CommonButton
      id="edit-report-notification"
      action={() => dispatch(actions.configurator.setFormModeReport('edit'))}
      scope="tertiary"
      value={t(actionType.EDIT_REPORTS_NOTIFICATION)}
      customIcon="cycle-circle-flux"
      disabled={!utils.user.isActionByCompanyActive(actionType.EDIT_REPORTS_NOTIFICATION) || !selectedRow || !!formMode}
    />
  );
};

export default EditReportNotification;
